/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of WKWebviewOmegaSDK
 */

import { IPlanObject } from 'com/didichuxing/IPlanObject';
import { IOmegaSDK, IAppSdkInfo } from 'com/didichuxing/tracker/plugin/app/IOmegaSDK';

export default class WKWebviewOmegaSDK implements IOmegaSDK {

    /**
     * 往WKWebview派发信息。
     * @param {string} methodName
     * @param {string} params
     */
    private postMessage(methodName: string, params: string): void {
        (window as any).webkit.messageHandlers[methodName].postMessage(params);
    }

    /**
     * @override
     * @inheritDoc
     * @param {string} tel
     * @param {string} countryCallingCode
     */
    public setTelephone(tel: string, countryCallingCode?: string): void {
        this.postMessage('setTelephone', JSON.stringify({
            tel: tel
        }));
    }

    /**
     * @override
     * @inheritDoc
     * @param {string} userId
     */
    public setUserId(userId: string): void {
        this.postMessage('setUserId', JSON.stringify({
            userId: userId
        }));
    }

    /**
     * @override
     * @inheritDoc
     * @param {number} cityId
     */
    public setCityId(cityId: number): void {
        this.postMessage('setCityId', JSON.stringify({
            cityId: cityId
        }));
    }

    /**
     * @override
     * @inheritDoc
     * @param {string} eventId
     * @param {string} eventLabel
     * @param {string} attrJson
     * @param {string} sysJson
     * @param {string} exJson
     */
    public trackEventEx(eventId: string, eventLabel: string, attrJson: string, sysJson: string, exJson: string): void {
        this.postMessage('trackEventEx', JSON.stringify({
            eventId: eventId,
            eventLabel: eventLabel,
            attrJson: attrJson,
            sysJson: sysJson,
            exJson: exJson
        }));
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getInfo(): string;
    public getInfo(cb: (info: IAppSdkInfo) => void): void;
    public getInfo(cb?: (info: IAppSdkInfo) => void): any {
        const callback = function(res: IAppSdkInfo) {
            window.postMessage((res as IPlanObject).info, location.href);
        };
        this.postMessage('getInfo', JSON.stringify({
            getInfo: callback.toString()
        }));
        const getInfoHandler = (evt: MessageEvent): void => {
            if (evt && evt.data && evt.data.oid) {
                window.removeEventListener('message', getInfoHandler);
                cb && cb(evt.data);
            }
        };
        window.addEventListener('message', getInfoHandler);
        return '';
    }
}
